import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import pt_BR from 'date-fns/locale/pt-BR';

registerLocale('pt-BR', pt_BR);

const METRIC_OPTIONS = [
    { value: 'oferta_final', label: 'Oferta Final' },
    { value: 'ticket_medio', label: 'Preço Médio' },
    { value: 'oferta_inicial', label: 'Lançamentos' },
    { value: 'vgv_final', label: 'VGV Oferta Final' },
];

const threeMonthsAgo = () => {
    const d = new Date();
    d.setMonth(d.getMonth() - 3);
    return d;
};

// Modal do mapa de calor para o MapBox (PrimeReact Dialog). Emite via addHeatMap
// o mesmo formato esperado por MapboxMap.addHeatMap: { type, data_inicial, data_final }.
export default function HeatMapModal({ show, closeModal, addHeatMap }) {
    const [type, setType] = useState(null);
    const [dataInicial, setDataInicial] = useState(threeMonthsAgo);
    const [dataFinal, setDataFinal] = useState(() => new Date());

    // O Dropdown do PrimeReact retorna o `value` primitivo da opção (string),
    // então `type` é a string da métrica (ex.: 'oferta_inicial').
    const isLancamentos = type === 'oferta_inicial';

    const handleSubmit = () => {
        const option = METRIC_OPTIONS.find((o) => o.value === type);
        if (!option) return;
        // addHeatMap espera { type: { value, label }, ... }.
        addHeatMap({ type: option, data_inicial: dataInicial, data_final: dataFinal });
        closeModal();
    };

    return (
        <Dialog
            header="Criar Mapa de Calor"
            visible={show}
            onHide={closeModal}
            modal
            style={{ width: '32rem', maxWidth: '90vw' }}
        >
            <div className="form-group">
                <label className="d-block">Mapa de Calor Por:</label>
                <Dropdown
                    value={type}
                    onChange={(e) => setType(e.value)}
                    options={METRIC_OPTIONS}
                    optionLabel="label"
                    appendTo={document.body}
                    placeholder="Selecione..."
                    className="w-100"
                />
            </div>

            {isLancamentos && (
                <div className="form-group row">
                    <div className="col-6">
                        <label>Lançamentos Data Inicial</label>
                        <DatePicker
                            className="form-control"
                            locale="pt-BR"
                            selected={dataInicial}
                            onChange={setDataInicial}
                            dateFormat="MM/yyyy"
                            appendTo={document.body}
                            showMonthYearPicker
                            showFullMonthYearPicker
                        />
                    </div>
                    <div className="col-6">
                        <label>Lançamentos Data Final</label>
                        <DatePicker
                            className="form-control"
                            locale="pt-BR"
                            selected={dataFinal}
                            onChange={setDataFinal}
                            appendTo={document.body}
                            dateFormat="MM/yyyy"
                            showMonthYearPicker
                            showFullMonthYearPicker
                        />
                    </div>
                </div>
            )}

            <div className="d-flex justify-content-end mt-3">
                <button className="btn btn-success" onClick={handleSubmit} disabled={!type}>
                    Criar Mapa de Calor
                </button>
            </div>
        </Dialog>
    );
}
